import { PiSquaresFour } from "react-icons/pi";

const SimpleMetricCard = ({ value, label, subtitle, iconColor = "bg-blue-500" }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
      <div className="flex items-start gap-4 mb-8">
        <div className={`${iconColor} rounded-xl p-4 flex items-center justify-center`}>
          <PiSquaresFour className="w-8 h-8 text-white" />
        </div>
        <div>
          <div className="text-4xl font-bold text-black">{value}</div>
          <div className="text-base text-gray-500 mt-1">{label}</div>
        </div>
      </div>
      
      {subtitle && (
        <div className="pt-4 border-t border-gray-100">
          <p className="text-sm text-gray-500">{subtitle}</p>
        </div>
      )}
    </div>
  );
};

export default SimpleMetricCard;
